import React from 'react';

const SvgOther47 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 16" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M16.994 14a1 1 0 1 1 0-1.999 1 1 0 0 1 0 2zM3.006 4a1 1 0 1 1 0-1.999 1 1 0 0 1 0 2zm11.17 8h-1.179A2 2 0 0 1 11 10V6c0-2.209-1.79-4-3.997-4h-1.18A2.997 2.997 0 0 0 0 3a2.997 2.997 0 1 0 5.823 1h1.18A2 2 0 0 1 9 6v4c0 2.21 1.79 4 3.996 4h1.18a2.997 2.997 0 0 0 5.803-1.344A2.998 2.998 0 0 0 14.176 12z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgOther47 svgRef={ref} {...props} />);
export default ForwardRef;
